export const axiosUrl = process.env.VUE_APP_API_BASE_URL
export const imgUrl = process.env.VUE_APP_IMG_BASE_URL
